module.exports = __webpack_public_path__ + "static/communication-b8585ba1e9495c0d7ff18ba9a65edd99.webp";